import { render, staticRenderFns } from "./hongbao.vue?vue&type=template&id=acc022da&scoped=true"
import script from "./hongbao.vue?vue&type=script&lang=js"
export * from "./hongbao.vue?vue&type=script&lang=js"
import style0 from "./hongbao.vue?vue&type=style&index=0&id=acc022da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc022da",
  null
  
)

export default component.exports